<template>
	<div class="row">
		<form class="col-lg-4 col-md-6 col-sm-8 col-xs-12 mx-auto" @submit.prevent="attemptLogin()">
			<div class="mb-3">
				<label for="username" class="form-label">Username</label>
				<input type="text" class="form-control" id="username" v-model.trim="username" required>
			</div>
			<div class="mb-3">
				<label for="password" class="form-label">Password</label>
				<input type="password" class="form-control" id="password" v-model="password" required>
			</div>
			<div class="form-text text-danger" v-if="errorMessage">
				{{ errorMessage }}
			</div>
			<div class="mb-3">
				Don't have an account?  <router-link :to="{ name: 'register' }">Register</router-link>.
			</div>
			<button type="submit" class="btn btn-primary">Login</button>
		</form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			username: "",
			password: "",
			errorMessage: null
		};
	},
	methods: {
		async attemptLogin() {
			const result = await this.$store.dispatch("account/login", {
				username: this.username,
				password: this.password
			});

			if(result.error) {
				this.errorMessage = result.error;
			} else {
				this.$router.push({
					name: "home"
				});
			}
		}
	}
};
</script>
